import { ChapterType } from '../../../models/admin';

export type ChapterFormResources = {
  [K in
    | 'addChapterTitle'
    | 'udpateChapterTitle'
    | 'chapterTypeLabel'
    | 'chapterTypePlaceHolder'
    | 'chapterStatusPlaceHolder'
    | 'chapterRightPlaceHolder'
    | 'addBtnTitle'
    | 'updateBtnTitle']: string;
};

// Default values for the resources
export const DefaultChapterFormResources: ChapterFormResources = {
  addChapterTitle: 'Add Chapter',
  udpateChapterTitle: 'Update Chapter',
  chapterTypeLabel: 'Type',
  chapterTypePlaceHolder: 'Change Chapter Type',
  chapterStatusPlaceHolder: 'Change Chapter Status',
  chapterRightPlaceHolder: 'Change Access Rights',
  addBtnTitle: 'Add',
  updateBtnTitle: 'Update',
};

// Chapter Status
export const ChapterStatusEnum = Object.freeze({
  Draft: { value: 'Draft', textValue: 'Draft' },
  WaitingForVerification: {
    value: 'WaitingForVerification',
    textValue: 'WaitingForVerification',
  },
  Verified: { value: 'Verified', textValue: 'Verified' },
  Published: { value: 'Published', textValue: 'Published' },
  Retired: { value: 'Retired', textValue: 'Retired' },
});

// Chapter Types
export const ChapterTypesEnum = Object.freeze(
  Object.keys(ChapterType)
    .filter((key) => isNaN(Number(key))) // Ignore numeric keys from reverse mapping
    .reduce(
      (acc, key) => {
        acc[key] = { value: key, textValue: key };
        return acc;
      },
      {} as Record<string, { value: string; textValue: string }>,
    ),
);
